import { render, staticRenderFns } from "./PartItem.vue?vue&type=template&id=51045cb2&scoped=true&"
import script from "./PartItem.vue?vue&type=script&lang=js&"
export * from "./PartItem.vue?vue&type=script&lang=js&"
import style0 from "./PartItem.vue?vue&type=style&index=0&id=51045cb2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51045cb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VTooltip})
